import { Tag } from 'antd';
import React from 'react';
import cx from 'classnames';
import './style.scss';

const { CheckableTag } = Tag;

class CheckTag extends React.Component {
  constructor(props) {
    super(props);
    this.state = { checked: false };
  }

  handleChange = (checked) => {
    this.setState({ checked });
  };

  render() {
    const { checked } = this.state;
    return (
      <div className={cx('tag_wrapper', {
        tag_wrapper_checked: checked,
      })}
      >
        <CheckableTag
          {...this.props}
          checked={this.state.checked}
          onChange={this.handleChange}
        />
      </div>
    );
  }
}

export { CheckTag };



// WEBPACK FOOTER //
// ./src/view/common/CheckTag/index.jsx